module.exports = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10"><path d="M1 4.1h8v1.8H1z"/></svg>';